import { jsxs as n, jsx as t } from "react/jsx-runtime";
const i = ({
  width: e = 24,
  height: r = 24,
  color: o = "var(--color-main)"
}) => /* @__PURE__ */ n(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "close-icon",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M18 6L6 18",
          stroke: o,
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6 6L18 18",
          stroke: o,
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  i as CloseIcon
};
